import { AnimatedChevron, IconSize } from '@ardoq/icons';
import { ComponentType } from 'react';
import { DropdownIndicatorProps } from 'react-select';
import { SelectOption } from '../../types';

export const DropdownIndicator: ComponentType<
  DropdownIndicatorProps<SelectOption<unknown>>
> = ({ selectProps: { menuIsOpen } }) => {
  return <AnimatedChevron $isUp={menuIsOpen} iconSize={IconSize.MEDIUM} />;
};
